import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  loading: false,
  currentProject: null,
};

export const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    addProject: state => {},
    deleteProject: state => {},
    setProjects: (state, action) => {
      state.items = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCurrentProject: (state, action) => {
      state.currentProject = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addProject,
  deleteProject,
  setProjects,
  setLoading,
  setCurrentProject,
} = projectsSlice.actions;

export default projectsSlice.reducer;
